import React from "react"
import Hero from "./hero/Hero"
import AboutCard from "../about/AboutCard"
import HProgramme from "./HProgramme"
import HWhyUs from "./HWhyUs"
import HExtra from "./HExtra"

// Removed: HAbout ("Explore Our Trading Courses") — moved to /courses page
// Hidden for now — can be re-enabled when ready
// import Testimonal from "./testimonal/Testimonal"
// import Hblog from "./Hblog"
// import Hprice from "./Hprice"

const Home = () => {
  return (
    <>
      <Hero />
      <AboutCard />
      <HProgramme />
      <HWhyUs />
      <HExtra />
    </>
  )
}

export default Home
